module.exports = __webpack_public_path__ + "media/images/logo-884a08e1c4aefa709cbb222fb779d80c.jpg";